module.exports = __webpack_public_path__ + "img/enLigne.3161a7c6.svg";